import * as React from "react"
import { Container, Modal, Row, Col, Button, Form } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { APIError } from "../../api/ObservableFromFetch"
import { EventUnexcuseObservable, GetExcuseNotesObservable, UpdateExcuseNotesObservable } from "../../api/Randoms/EventExcuse"
import SelectionInboxGridRow from "../../api/Randoms/SelectionInboxModel/SelectionInboxGridRow"
import ActionButton from "../ActionButton"
import FormatError from "../../formatters/FormatError"

interface UnexcuseEventModalModalProps {
  show: boolean
  excuseDetails?: SelectionInboxGridRow
  onClose: (success: boolean) => void
}

interface UnexcuseEventModalState {
  comment: string
  saving: boolean
  loading: boolean
}

export default class UnexcuseEventModalModal extends React.PureComponent<UnexcuseEventModalModalProps, {}> {
  state: UnexcuseEventModalState = { comment: "", saving: false, loading: false }
  saveSubscription?: Subscription
  loadSubscription?: Subscription

  componentDidMount() {
    this.setState({ loading: true })
    this.loadSubscription && this.loadSubscription.unsubscribe()
    this.loadSubscription = GetExcuseNotesObservable(this.props.excuseDetails!.TestDetailID).subscribe(
      (result: string) => this.setState({ comment: result, loading: false }),
      error => this.handleAPIError(error, { loading: false })
    )

  }

  componentWillUnmount() {
    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.loadSubscription && this.loadSubscription.unsubscribe()
  }

  unexcuse = () => {
    this.setState({ saving: true })
    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.saveSubscription = EventUnexcuseObservable(this.props.excuseDetails!.TestEventID, this.props.excuseDetails!.TestDetailID).subscribe(
      result => {
        toast.success(result)
        this.props.onClose(true)
      },
      error => this.handleAPIError(error, { saving: false })
    )
  }

  updateComment = () => {
    this.setState({ saving: true })
    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.saveSubscription = UpdateExcuseNotesObservable(this.props.excuseDetails!.TestDetailID, this.state.comment.trim()).subscribe(
      result => {
        toast.success(result)
        this.props.onClose(true)
      },
      error => this.handleAPIError(error, { saving: false })
    )
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error(FormatError(error))
  }

  render() {
    const { saving, loading } = this.state
    const disableUpdateButton = (this.state.comment.trim().length === 0) || loading || saving

    return <Modal backdrop="static" centered show={this.props.show} onHide={() => this.props.onClose(false)} size="lg">
      <Modal.Header closeButton={true}>
        <Modal.Title>UNEXCUSE EVENTS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Row className="form-group required">
            <Form.Label column lg={3} htmlFor="comment">Reason for excusing</Form.Label>
            <Col lg={9}>
              <Form.Control
                id="comment"
                as="textarea"
                rows={3}
                value={this.state.comment}
                onChange={e => this.setState({ comment: e.target.value })} />
            </Col>
          </Form.Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => this.props.onClose(false)} className="mr-auto fixed-w5">CANCEL</Button>
        <ActionButton variant="primary" onClick={() => this.updateComment()} disabled= {disableUpdateButton} spin={saving} disableOnSpin={true} className="fixed-w5">UPDATE</ActionButton>
        <ActionButton variant="primary" onClick={() => this.unexcuse()} spin={saving} disableOnSpin={true} className="fixed-w5">UNEXCUSE</ActionButton>
      </Modal.Footer>
    </Modal>
  }
}